import { IntroScreenUIConfig } from "../../components/ui/intro-screen-ui";
import { SingleScenarioInfoConfig } from "../../components/ui/scenario-info-ui";
import GameManager from "../../cvp-webgames-core/GameManager";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { VideoSegmentItem, SingleVideoSegmentItem } from "../../cvp-webgames-core/VideoSegment/VideoSegmentItem";
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from "../../cvp-webgames-core/pre-caching/pre-cache-item";
import { PageType } from "../../misc/tools";
import { GameBaseScenario } from "../GameBaseScenario";
import WcWorkStoppageComponentsStep0Component from "./components/wc-work-stoppage-components-step0/wc-work-stoppage-components-step0";
import WcWorkStoppageComponentsStep0Part1 from "./components/wc-work-stoppage-components-step0/wc-work-stoppage-components-step0-parts/wc-work-stoppage-components-step0-part1";
import WcWorkStoppageComponentsStep1Component from "./components/wc-work-stoppage-components-step1/wc-work-stoppage-components-step1";
import WcWorkStoppageComponentsStep1Part1 from "./components/wc-work-stoppage-components-step1/wc-work-stoppage-components-step1-parts/wc-work-stoppage-components-step1-part1";
import WcWorkStoppageComponentsStep2Component from "./components/wc-work-stoppage-components-step2/wc-work-stoppage-components-step2";
import WcWorkStoppageComponentsStep2Part1 from "./components/wc-work-stoppage-components-step2/wc-work-stoppage-components-step2-parts/wc-work-stoppage-components-step2-part1";

class Scenario4WcWorkStoppageVideoSegments extends VideoSegmentItem {
	public get title(): string {
		return 'Scenario 4 Wc Work Stoppage';
    }
	public getItems(): SingleVideoSegmentItem[] {
		return [
			{
				key: 'Scenario 4 Video 1',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario04/sc04-cinematic/cin-sc-4.mp4',
				chapterIds: [
					'Chapter 1'
				]
			},
			{
				key: 'MixedMedia',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario04/sc04-mentor/mntr-sc-04.mp4', // change this
				chapterIds: [
					'step-2'// alan to update premiere file with audios lol at the end of the time code.
				]
			},
			{
				key: 'Feedback',
				src: process.env.PUBLIC_URL + '/assets/videos/scenario04/sc04-mentor/mntr-sc-04.mp4', // change this
				chapterIds: [
					'scenario4-5', //question 1 correct - don't delete comment!
					'scenario4-3', //question 1 incorrect - don't delete comment!
					'scenario4-4', //question 1 other option - don't delete comment!
					'scenario4-9',//question 2 correct - don't delete comment!
					'scenario4-7', //question 2 incorrect - don't delete comment!
					'scenario4-8', //question 2 other option - don't delete comment!
					'scenario4-13', //question 3 correct - don't delete comment!
					'scenario4-12', //question 3 incorrect - don't delete comment!
					'scenario4-16', //question 4 correct - don't delete comment!
					'scenario4-17', //question 4 incorrect - don't delete comment!
					'scenario4-18', //question 4 other option - don't delete comment!
					'scenario4-22', //question 5 correct - don't delete comment!
					'scenario4-21', //question 5 incorrect - don't delete comment!
					'scenario4-1', //scenario info 
					'scenario4-23' //scenario review 
				]
			}
		];
	}
}

export const scenario4WcWorkStoppageVideoSegments = new Scenario4WcWorkStoppageVideoSegments();

class Scenario4WcWorkStoppageAudioCaching extends PreCacheItem {
    public audioKeys = {
        question1: 'question1',
        question2: 'question2',
        question3: 'question3',
        question4: 'question4',
        question5: 'question5'
    };
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question1,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-04/mentor/jcdst-mentor-vo-scn-04-04.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question2,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-04/mentor/jcdst-mentor-vo-scn-04-09.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question3,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-04/mentor/jcdst-mentor-vo-scn-04-15.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question4,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-04/mentor/jcdst-mentor-vo-scn-04-20.mp3'
			},
			{
				type: PrecacheItemType.Audio,
				key: this.audioKeys.question5,
				src: process.env.PUBLIC_URL + '/assets/voiceover/scenario-04/mentor/jcdst-mentor-vo-scn-04-25.mp3'
			}
		];
	}
}

export const scenario4WcWorkStoppageAudioCaching = new Scenario4WcWorkStoppageAudioCaching();

export default class Scenario4WcWorkStoppage extends GameBaseScenario {
	public comp1Step1FirstSelectedChoiceIndex: number = -1;
	public getMentorVideoURLs(): SingleVideoSegmentItem[] {
		return [
			scenario4WcWorkStoppageVideoSegments.getItemByKey('MixedMedia'),
			scenario4WcWorkStoppageVideoSegments.getItemByKey('Feedback'),
		] 
	}
	public getScenarioInfo(): SingleScenarioInfoConfig {
		return {
			scenarioId: PageType.Scenario4WcWorkStoppage,
			title: 'Gloving',
			subtitle: 'Situation/Background',
			img: process.env.PUBLIC_URL + '/assets/images/scenarios/sample-image.png',
			description: `
				<p class="small-text" style="margin: 20px; text-align: center">
				After this learning activity you will be able to apply the Just Culture Decision Support Tool after an adverse event occurs.
				
				A staff physician removing a cyst from the arm of a teenage boy decides at the last 
				minute to take a culture while the incision in the boy’s arm is still open. A swab is 
				not available as she was not expecting to culture the wound. The nurse has left the room 
				to admit another patient as the clinic schedule is overbooked today. To find a swab, 
				the doctor opens a few drawers and cabinets. The doctor does this without removing her 
				gloves, engaging in any hand hygiene, and re-gloving between contacts with the incision. The 
				culture is taken with the swab. Later the patient’s family went to the Clinic director 
				and expressed concerns. 
				</p>
			`,
			mentorVideoUrl: scenario4WcWorkStoppageVideoSegments.getItemByKey('Feedback').src,
			mentorChapterId: scenario4WcWorkStoppageVideoSegments.getItemByKey('Feedback').chapterIds[13]
		}
    }
	public resumeScenarioFromArea(areaIndx: number): void {
		switch(areaIndx) {
			case 0:
				(this.step0Component.parts[0] as WcWorkStoppageComponentsStep0Part1).section2();
				break;
			case 1:
				(this.step0Component.parts[0] as WcWorkStoppageComponentsStep0Part1).section3();
				break;
			case 2:
				(this.step1Component.parts[0] as WcWorkStoppageComponentsStep1Part1).section2();
				break;
			case 3:
				(this.step1Component.parts[0] as WcWorkStoppageComponentsStep1Part1).section3();
				break;
			case 4:
				(this.step2Component.parts[0] as WcWorkStoppageComponentsStep2Part1).section1();
				break;
			case 5:
				(this.step2Component.parts[0] as WcWorkStoppageComponentsStep2Part1).section2();
				break;
			case 6:
				(this.step1Component.parts[0] as WcWorkStoppageComponentsStep1Part1).section1();
				break;
		}
	}

	//VALUES BELOW ARE FOR DEBUG PURPOSES IN CASE STEP 1 is SKIPPED
	// public comp1Step1FirstSelectedChoiceIndex: number = 0;
	public scenarioId(): PageType {
		return PageType.Scenario4WcWorkStoppage;
    }

	private video: SingleVideoSegmentItem = scenario4WcWorkStoppageVideoSegments.getItemByKey('Scenario 4 Video 1');
	public getScenarioVideoURL(): string {
		return this.video.src;
	}
	public introScreenInfo(): IntroScreenUIConfig {
		return {
		title: 'Gloving',
		subtitle: 'Incident Report',
		name: 'Dr. Jones',
		position: 'Staff Physician',
		time: '2:00 pm',
		place: 'Clinic',
		desc: `A staff physician removing a cyst from the arm of a teenage boy decides at the 
		last minute to take a culture while the incision in the boy’s arm is still open. 
		A swab is not available as she was not expecting to culture the wound. The nurse 
		has left the room to admit another patient as the clinic schedule is overbooked today. 
		To find a swab, the doctor opens a few drawers and cabinets. The doctor does this without 
		removing his gloves, engaging in any hand hygiene, and re-gloving between contacts with 
		the incision. The culture is taken with the swab. Later the patient’s family went to 
		the Clinic director and expressed concerns.`,
		repeat: 'No',
		okButton: 'Continue'
		}
	}

	private step0Component = new WcWorkStoppageComponentsStep0Component({
		scenario: this,
		onDone: () => {
			this.goToStep1Component();
		}
	})

	private step1Component = new WcWorkStoppageComponentsStep1Component({
		scenario: this,
		onDone: () => {
			this.goToStep2Component();
		}
	})

	private step2Component = new WcWorkStoppageComponentsStep2Component({
		scenario: this,
		onDone: () => {
			this.uiWrapper.displayAAR();
		}
	})

	private parts: BaseScenarioPart<GameBaseScenario>[] = [].concat(this.step0Component.parts)
		.concat(this.step1Component.parts)
		.concat(this.step2Component.parts);

	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
		this._setupStep0Component();
		this._setupStep1Component();
		this._setupStep2Component();
	}

	start() {
		this.goToStep0Component();
	}

	private _setupStep0Component() {
		this.step0Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep1Component() {
		this.step1Component.config.part1Config = {
			chapter: () => {
				return this.video.chapterIds[0];
			},
			videoUrl: this.video.src
		}
	}

	private _setupStep2Component() {
		this.step2Component.config.part1Config = {
			videoUrl: this.video.src
		}
	}

	public getParts(): BaseScenarioPart<GameBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return process.env.PUBLIC_URL + '/assets/audio/scenario1/' + fileName + '.ogg';
	}

	goToStep0Component() {
		this.step0Component.start();
	}

	goToStep1Component() {
		this.step1Component.start();
	}

	goToStep2Component() {
		this.step2Component.start();
	}
}